import { DateTime } from 'luxon';

export const OLDEST_TIME = '2000-01-01T00:00:00.000Z';

export const REPORTING_GRACE_PERIOD = 2; // 2 minutes to allow for small delays in reporting/syncing.

export const isOutsideOfReportingGracePeriod = (
  reportTime: DateTime,
  otherTime: DateTime,
): boolean => {
  const { minutes } = otherTime.diff(reportTime, ['minutes']).toObject();
  return typeof minutes !== 'undefined' && minutes > REPORTING_GRACE_PERIOD;
};
